import { createTheme } from '@mui/material/styles';
export const themeStyles = createTheme({
    typography: {
        fontFamily: 'Inter, sans-serif',
  
    },

});